import { Autoplay, Navigation, Pagination, Keyboard } from "swiper";
import { SwiperSetup } from '@resources/swiper-setup/SwiperSetup'
import { reinitVideos, initIfAtLeast, stopIframes } from "@resources/swiper-setup/SwipertSetup.utils";

SwiperSetup.register('highlights', ({ swiperId, swiperTag, swiperEl }) => {
	return {
		modules: [Autoplay, Navigation, Keyboard, Pagination],
		direction: 'horizontal',
		loop: false,
		speed: 650,
		slidesPerView: 1,
		autoHeight: false,
		spaceBetween: 36,
		autoplay: {
			delay: 5000,
			disableOnInteraction: true,
		},
		pagination: {
			el: swiperEl.parentNode.querySelector(`.swiper-pagination`),
			clickable: true,
		},
		navigation: {
			nextEl: swiperEl.parentNode.querySelector('.swiper-button-next'),
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		init: initIfAtLeast(swiperEl),
		on: {
			slideChange: () => {
				reinitVideos(swiperEl);
				stopIframes(swiperEl);
			},
			init: () => {
				if( !swiperEl.closest('.explore') ) return;
				let interval = setInterval(() => {
					if( SwiperSetup.swiperList[swiperId] ){
						window.teste = SwiperSetup.swiperList[swiperId];
						SwiperSetup.swiperList[swiperId].autoplay.pause()
						clearInterval(interval);
					}
				}, 500);
			}
		}
	}
})
